(() => {
  if (window.__thbBrandsV2Loaded) return;
  window.__thbBrandsV2Loaded = true;
  const instances = new WeakMap();
  const normalize = value => String(value || '').toLocaleLowerCase('en').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i').trim();
  const initialize = root => {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const {signal} = controller;
    const search = root.querySelector('[data-brands-search]');
    const form = root.querySelector('[data-brands-search-form]');
    const entries = Array.from(root.querySelectorAll('[data-brand-entry]'));
    const groups = Array.from(root.querySelectorAll('[data-brands-group]'));
    const rangeLinks = Array.from(root.querySelectorAll('[data-brands-group-link]'));
    const reset = root.querySelector('[data-brands-reset]');
    const empty = root.querySelector('[data-brands-empty]');
    const status = root.querySelector('[data-brands-status]');
    let activeGroup = '';
    let announceTimer;
    if (!search || !form || !reset || !empty || !status) return;
    const update = (announce = true) => {
      const query = normalize(search.value);
      let count = 0;
      entries.forEach(entry => {
        const matches = (!activeGroup || entry.dataset.brandGroup === activeGroup) && normalize(entry.dataset.brandName).includes(query);
        entry.hidden = !matches;
        if (matches) count += 1;
      });
      groups.forEach(group => {
        group.hidden = !Array.from(group.querySelectorAll('[data-brand-entry]')).some(entry => !entry.hidden);
      });
      rangeLinks.forEach(link => {
        if (link.dataset.brandsGroupLink === activeGroup) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      empty.hidden = count > 0;
      root.querySelector('[data-brands-featured]')?.toggleAttribute('hidden', Boolean(query || activeGroup));
      root.querySelector('.thb-brands-v2__hero')?.toggleAttribute('hidden', Boolean(query || activeGroup));
      root.querySelector('.thb-brands-v2__benefits')?.toggleAttribute('hidden', Boolean(query || activeGroup));
      reset.hidden = !query && !activeGroup;
      clearTimeout(announceTimer);
      status.textContent = count + ' ' + status.dataset.countLabel;
      if (announce) announceTimer = setTimeout(() => status.setAttribute('data-result-count', String(count)), 120);
    };
    const clear = () => {
      search.value = '';
      activeGroup = '';
      update();
    };
    form.addEventListener('submit', event => {
      event.preventDefault();
      update();
      root.querySelector('.thb-brands-v2__directory')?.scrollIntoView({block: 'start', behavior: 'auto'});
    }, {signal});
    search.addEventListener('input', () => { activeGroup = ''; update(); }, {signal});
    search.addEventListener('search', () => { activeGroup = ''; update(); }, {signal});
    reset.addEventListener('click', () => {
      clear();
      search.focus({preventScroll: true});
    }, {signal});
    rangeLinks.forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      activeGroup = activeGroup === link.dataset.brandsGroupLink ? '' : link.dataset.brandsGroupLink;
      search.value = '';
      update();
      const directory = root.querySelector('.thb-brands-v2__directory');
      directory?.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }, {signal}));
    root.addEventListener('shopify:block:select', event => {
      if (!event.detail?.blockId) return;
      const selected = entries.find(entry => entry.dataset.brandBlock === event.detail.blockId);
      if (!selected) return;
      clear();
      selected.scrollIntoView({block: 'center', behavior: 'auto'});
    }, {signal});
    update(false);
    root.setAttribute('data-brands-ready', '');
    instances.set(root, () => {
      clearTimeout(announceTimer);
      controller.abort();
      root.removeAttribute('data-brands-ready');
      instances.delete(root);
    });
  };
  const findRoots = scope => {
    const roots = Array.from(scope.querySelectorAll('[data-brands-v2]'));
    if (scope.matches?.('[data-brands-v2]')) roots.unshift(scope);
    return roots;
  };
  const load = scope => findRoots(scope).forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => load(document), {once: true});
  else load(document);
  document.addEventListener('shopify:section:load', event => load(event.target));
  document.addEventListener('shopify:section:unload', event => findRoots(event.target).forEach(root => instances.get(root)?.()));
})();
